import CustomLoginButton from "./Header/CustomLoginButton";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useWallet } from "@solana/wallet-adapter-react";
import TokensTable from "./TokensTable/TokensTable";

function Flow(props) {
  const tokens = useSelector(s => s.user.tokens);
  const solBalance = useSelector(s => s.user.solBalance);
  const [successRate, setSuccessRate] = useState(17);
  const { connected, connecting, disconnecting, publicKey } = useWallet();
  const roundedSolBalance = parseFloat(solBalance).toFixed(2);
  const address = connected
    ? publicKey?.toString().substr(0, 4) + "..." + publicKey?.toString().substr(-4)
    : "";
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [step4, setStep4] = useState(false);

  const [about, setAbout] = useState(false);

  const closeSteps = () => {
    console.log("close step");
    setStep1(true);
    setStep2(false);
    setStep3(false);
    setStep4(false);
  };

  const goToStep3 = () => {
    setStep1(false);
    setStep2(false);
    setStep3(true);
    setStep4(false);
  };
  const goToStep2 = () => {
    setStep1(false);
    setStep2(true);
    setStep3(false);
    setStep4(false);
  };
  const goToStep4 = () => {
    setStep1(false);
    setStep2(false);
    setStep3(false);
    setStep4(true);
  };

  const pageName = window.location.pathname.toLowerCase();
  let projectName;

  switch (true) {
    case pageName.includes("mbb"):
      projectName = "Monkey Baby Busines";
      break;
    case pageName.includes("mfolk"):
      projectName = "Mindfolk";
      break;
    case pageName.includes("smyth"):
      projectName = "Smyths";
      break;
    case pageName.includes("ggsg"):
      projectName = "Galactic Geckos";
      break;
    case pageName.includes("smb"):
      projectName = "Solana Monkey Business";
      break;
    case pageName.includes("fff"):
      projectName = "Famous Fox Federation";
      break;
    case pageName.includes("clay"):
      projectName = "Claynosaurz";
      break;
    case pageName.includes("daa"):
      projectName = "Degen Ape Academy";
      break;
    case pageName.includes("taiyo"):
      projectName = "Taiyo Ecosystem";
      break;
    case pageName.includes("okb"):
      projectName = "Okay Bears";
      break;
    case pageName.includes("jelly"):
      projectName = "Jelly Ecosystem";
      break;
    case pageName.includes("dfc"):
      projectName = "Degen Fat Cats";
      break;
    case pageName.includes("boku"):
      projectName = "Boryoku Dragonz";
      break;
    case pageName.includes("cwm"):
      projectName = "Catalina Whale Mixer";
      break;
    case pageName.includes("abc"):
      projectName = "Abracadabra";
      break;
    case pageName.includes("oogy"):
      projectName = "Oogy";
      break;
    case pageName.includes("sac"):
      projectName = "Stoned Ape Crew";
      break;
    case pageName.includes("aury"):
      projectName = "Aurory";
      break;
    case pageName.includes("ovol"):
      projectName = "Elixir: Ovols";
      break;
    case pageName.includes("port"):
      projectName = "Portals";
      break;
    case pageName.includes("prim"):
      projectName = "Primates";
      break;
    case pageName.includes("coc"):
      projectName = "Cets on Creck";
      break;
    case pageName.includes("lily"):
      projectName = "Lily";
      break;
    case pageName.includes("heist"):
      projectName = "The Heist";
      break;
    case pageName.includes("madlad"):
      projectName = "Mad Lads";
      break;
    default:
      projectName = "";
      break;
  }

  useEffect(() => {}, []);

  return (
    <>
      <main className="relative md:pt-26 lg:pt-20 w-full z-10 flex-1 mx-auto overflow-x-hidden max-w-[1400px] flex flex-col justify-center items-center xl:mt-14 heightSmall:mt-16 h-fit md:h-screen pb-6">
        {!connected && step1 && !about ? (
          <div id="step1" className="w-full flex flex-col justify-center items-center">
            <img alt="y00ts logo" width="250" height="250" src="/logo-y00tlabs.png" />
            <div className="text-[18px] gap-2 justify-center -space-y-12 text-center">
              <p className="font-primary text-[16px] md:text-[18px] max-w-[800px] m-auto">
                <span className="text-connect font-primaryBold">Connect</span> your wallet to join
                our most <span className="text-orange font-primaryBold">ambitious </span>
                adventure <span className="text-yet font-primaryBold">yet</span>.
              </p>
            </div>
            <div className="buttonRoot mt-10 w-full shadow-none rounded-lg flex justify-center">
              <button className="border border-[#000000] py-2 px-6 md:px-8 font-primary text-[18px] md:text-[23px] bg-[#1D1D1F] text-white whitespace-nowrap">
                <CustomLoginButton text="Connect Wallet" />
              </button>
            </div>
            <div className="mt-5 flex justify-center">
              <video width="450" height="450" autoPlay loop playsInline muted>
                <source src="/forever-young-2.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        ) : (
          <></>
        )}
        {connected && step3 === false && step4 === false && !about ? (
          <div
            id="step2"
            className="pt-5 pb-8 px-8 w-11/12 max-w-[411px] h-fit border-solid border-2 border-black z-10 rounded-none bg-white"
          >
            <div className="h-fit md:h-[460px] y00ts:md:h-[480px]">
              <div className="flex justify-between mb-3">
                <div className="flex w-fit divide-x-2 py-2">
                  <svg
                    width="31"
                    height="20"
                    className="pr-2"
                    viewBox="0 0 42 45"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M14.541 39.2242C16.0924 39.1404 17.6455 39.055 19.1576 38.9729C19.3317 37.2071 19.4443 35.6039 19.6611 34.0157C19.8266 32.8078 20.1321 31.62 20.3676 30.4205C21.32 25.5738 22.2433 20.7205 23.2315 15.8805C23.8186 12.999 24.4808 10.1309 25.1703 7.27113C25.3239 6.63787 25.754 6.07329 26.0322 5.46515C26.307 4.86707 26.5254 4.24218 26.8156 3.65248C26.9572 3.36265 27.1603 3.06947 27.4112 2.86676C28.1058 2.30553 28.78 1.68232 29.5685 1.2836C31.2956 0.405737 33.1099 -0.383331 35.1152 0.20135C36.4482 0.59002 37.4876 1.50306 38.3511 2.5518C40.604 5.28925 41.4676 8.52928 41.8704 11.9536C42.309 15.6912 41.5444 19.3115 40.9214 22.9536C40.5084 25.3627 40.2763 27.8137 39.679 30.1759C39.0884 32.5096 38.1668 34.7662 37.3271 37.0329C37.1599 37.4819 37.1291 37.7717 37.4329 38.1453C37.9262 38.7501 38.3682 39.3967 38.8597 40.0669C39.1806 39.8742 39.4503 39.7134 39.9008 39.4453C39.8667 39.8926 39.8411 40.1691 39.824 40.4455C39.7797 41.129 39.7011 41.8109 39.7046 42.4944C39.7063 43.0724 39.4144 43.3454 38.7846 43.2416C37.5934 43.0439 36.7264 42.3687 36.0283 41.4406C35.8269 41.1726 35.6324 40.9012 35.39 40.5711C35.2415 40.7588 35.0913 40.8861 35.0214 41.0469C33.784 43.843 31.6421 45.2302 28.5223 44.9688C26.8343 44.8264 25.1447 44.6136 23.4858 44.2886C22.2723 44.0507 21.2107 43.3957 20.4564 42.3972C20.0673 41.8829 19.6218 41.8377 19.0569 41.9499C17.0037 42.357 14.9642 42.3821 12.9247 41.8058C12.5527 41.7003 11.9963 41.7556 11.6908 41.9667C8.98736 43.8413 4.36391 43.5398 2.79374 39.8022C2.23395 38.4703 1.70487 37.125 1.16214 35.7848C1.12118 35.6826 1.11435 35.5519 1.04438 35.4782C-0.128128 34.2385 -0.329518 32.4225 0.522125 30.8929C0.622821 30.712 0.651834 30.4674 0.643301 30.2563C0.474338 26.2071 1.45398 22.3221 2.37731 18.427C2.83129 16.5104 3.21359 14.5738 3.72048 12.6706C4.45266 9.92649 5.84874 7.53415 7.86947 5.49028C8.13742 5.22056 8.3098 4.80843 8.40025 4.43149C8.60506 3.58379 9.15632 3.14486 10.0575 3.03429C10.6838 2.95722 11.2812 2.67577 11.9058 2.54342C13.7047 2.16313 15.5035 1.96042 17.1659 3.00581C19.202 4.28406 20.5946 6.06659 21.3063 8.33662C21.4446 8.7789 21.4668 9.26474 21.4924 9.73215C21.675 13.2051 21.9037 16.6746 21.0196 20.1056C19.97 24.1733 19.004 28.2627 17.9254 32.3236C17.2819 34.7444 16.0377 36.8989 14.4778 38.8791C14.5 38.993 14.5205 39.1069 14.5427 39.2208L14.541 39.2242ZM35.0862 34.0375C35.1784 34.0492 35.2723 34.0609 35.3644 34.0726C35.8457 32.3973 36.4431 30.7438 36.781 29.0417C37.3049 26.4031 37.5985 23.7193 38.09 21.074C38.5815 18.4236 38.9451 15.7884 38.8478 13.0727C38.7676 10.796 38.1771 8.66666 37.322 6.61944C36.7588 5.27249 35.9191 3.98921 34.4974 3.27051C34.3199 3.18004 34.0827 3.12643 33.8898 3.15659C33.2566 3.25878 32.6371 3.44474 32.0022 3.5285C31.2496 3.62567 29.9235 4.82519 29.9508 5.48861C29.9968 6.65629 30.0668 7.82398 30.1419 8.99167C30.3382 12.0943 30.5003 15.1987 30.7614 18.2963C30.8894 19.8091 31.0601 21.3454 31.4731 22.8012C32.2821 25.6609 33.2737 28.4704 34.1919 31.3C34.4872 32.213 34.7893 33.1244 35.0879 34.0375H35.0862ZM27.2832 12.4126C27.2252 12.4043 27.1671 12.3959 27.1091 12.3875C26.9572 12.9387 26.7558 13.4815 26.6619 14.0427C26.3889 15.6879 26.225 17.3514 25.8991 18.9849C24.9604 23.669 23.9142 28.333 23.0113 33.0222C22.6495 34.9002 22.4703 36.8218 22.3662 38.7317C22.2808 40.2847 22.8628 41.0419 24.4006 41.3602C25.9127 41.6735 27.476 41.7606 29.0206 41.9147C30.473 42.0605 31.439 41.4054 32.0364 40.1138C32.3521 39.4319 32.8129 38.8137 33.1269 38.1302C33.2481 37.8672 33.2379 37.4701 33.1303 37.1954C32.7771 36.2941 32.2838 35.4414 31.9681 34.5283C31.1301 32.1142 30.2802 29.7001 29.5787 27.2474C28.8875 24.825 28.2082 22.379 27.8259 19.8996C27.447 17.4335 27.447 14.9105 27.2815 12.4126H27.2832ZM8.70917 9.55624C8.62383 9.53112 8.53679 9.50599 8.45146 9.47918C8.08451 10.2096 7.60323 10.9082 7.37111 11.6772C6.77889 13.639 6.23616 15.6208 5.7873 17.6195C5.11486 20.6233 4.39292 23.6271 3.96113 26.6678C3.40474 30.583 3.47472 34.4697 5.4306 38.1285C6.39829 39.9412 7.07585 40.3701 9.14438 39.9111C10.2469 39.6665 10.9961 38.3798 10.6582 37.3579C10.5541 37.0446 10.5131 36.7062 10.4841 36.3745C10.3425 34.6875 10.2025 32.9988 10.0865 31.3101C9.90386 28.6497 9.7366 25.9876 9.57276 23.3272C9.34918 19.665 9.13755 16.0028 8.91397 12.3423C8.85765 11.4125 8.77744 10.4827 8.70917 9.55457V9.55624ZM13.4606 34.5585C14.7799 32.6218 15.3414 30.4406 15.8773 28.2644C16.5156 25.6743 16.9525 23.0324 17.6728 20.4658C18.3827 17.9411 18.7668 15.4148 18.5619 12.808C18.4237 11.0556 18.7053 9.23459 17.5994 7.6397C16.6726 6.30281 15.6384 5.16025 13.8105 5.30432C13.2968 5.34453 12.8104 5.70305 12.2967 5.7466C11.5867 5.80692 11.5611 6.18051 11.6003 6.71158C11.7761 9.12067 11.9434 11.5314 12.097 13.9422C12.2369 16.1084 12.3461 18.2745 12.4878 20.4407C12.696 23.6271 12.9179 26.8135 13.1363 30C13.2405 31.5195 13.3514 33.0406 13.4589 34.5601L13.4606 34.5585Z"></path>
                  </svg>
                </div>
                <div
                  onClick={closeSteps}
                  className="flex items-center gap-2 hover:cursor-pointer py-3"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1.67156 16C1.24668 16 0.821803 15.8435 0.486373 15.5082C-0.162124 14.8599 -0.162124 13.7869 0.486373 13.1387L13.1433 0.486203C13.7918 -0.162068 14.8651 -0.162068 15.5136 0.486203C16.1621 1.13447 16.1621 2.20747 15.5136 2.85574L2.85674 15.5082C2.54367 15.8435 2.09644 16 1.67156 16Z"></path>
                    <path d="M14.3284 16C13.9036 16 13.4787 15.8435 13.1433 15.5082L0.486373 2.85574C-0.162124 2.20747 -0.162124 1.13447 0.486373 0.486203C1.13487 -0.162068 2.20825 -0.162068 2.85674 0.486203L15.5136 13.1387C16.1621 13.7869 16.1621 14.8599 15.5136 15.5082C15.1782 15.8435 14.7533 16 14.3284 16Z"></path>
                  </svg>
                </div>
              </div>
              <div className="flex flex-col text-center items-center mt-[71px] mb-[85px] y00ts:mb-[100px]">
                <img alt="matic" width="104" height="104" src="/migration-matic.svg" />
                <div className="font-primaryBold mt-2 text-lg">Does your bl00p get you a y00t?</div>
                <div className="text-fontSecondary text-sm w-5/6 y00ts:text-xs mt-1">
                  Get ready to experience y00topia. A cross-chain experiment designed by y00tLabs.
                </div>
              </div>
              <div className="flex flex-col gap-3 items-center">
                <div className="buttonRoot w-fit shadow-sm rounded-lg ">
                  <button
                    onClick={goToStep3}
                    className="buttonBase
                 
          w-[178px] h-[40px] bg-black text-white rounded-none  shadow-sm py-2 disabled:text-opacity-70 disabled:cursor-not-allowed
        "
                  >
                    Start y00tDraw
                  </button>
                </div>
                <img
                  alt="wormhole"
                  width="85.5"
                  height="25.5"
                  src="https://powered.by.dustlabs.com/cdn-cgi/image/width=256/https://y00ts.com/shared/brands/migration-wormhole.svg"
                />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {step3 && !about ? (
          <div
            id="step3"
            className="pt-5 pb-8 px-8 bg-white w-11/12 max-w-[411px] h-fit border-2 border-solid border-black z-10 rounded-none"
          >
            <div className="h-fit md:h-[340px]">
              <div className="flex justify-between mb-3">
                <div
                  onClick={goToStep2}
                  className="flex items-center gap-2 hover:cursor-pointer py-3 undefined"
                >
                  <img
                    alt="Go Back"
                    width="16"
                    height="12"
                    src="https://powered.by.dustlabs.com/cdn-cgi/image/width=32/https://y00ts.com/shared/icons/back-arrow.svg"
                  />
                </div>
                <div
                  onClick={closeSteps}
                  className="flex items-center gap-2 hover:cursor-pointer py-3"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1.67156 16C1.24668 16 0.821803 15.8435 0.486373 15.5082C-0.162124 14.8599 -0.162124 13.7869 0.486373 13.1387L13.1433 0.486203C13.7918 -0.162068 14.8651 -0.162068 15.5136 0.486203C16.1621 1.13447 16.1621 2.20747 15.5136 2.85574L2.85674 15.5082C2.54367 15.8435 2.09644 16 1.67156 16Z"></path>
                    <path d="M14.3284 16C13.9036 16 13.4787 15.8435 13.1433 15.5082L0.486373 2.85574C-0.162124 2.20747 -0.162124 1.13447 0.486373 0.486203C1.13487 -0.162068 2.20825 -0.162068 2.85674 0.486203L15.5136 13.1387C16.1621 13.7869 16.1621 14.8599 15.5136 15.5082C15.1782 15.8435 14.7533 16 14.3284 16Z"></path>
                  </svg>
                </div>
              </div>
              <div className="flex flex-col gap-5 items-center">
                <div className="w-full flex flex-col items-center text-center mb-5">
                  <div className="flex justify-center items-center mb-2">
                    <img alt="metamask" width="40" height="40" src="/image6.png" />
                    <img alt="phantom" width="32" height="32" src="/image12.png" />
                  </div>
                  <div className="font-primaryBold text-xl">EVM Wallet</div>
                  <div className="text-fontSecondary w-5/6 mt-1 text-xs">
                    Ensure you have an Ethereum Virtual Machine wallet (e.g. MetaMask/Phantom) to
                    receive your y00t if your Draw is successful.
                  </div>
                </div>

                <div className="buttonRoot w-fit shadow-sm !transform-none">
                  <button
                    onClick={goToStep4}
                    className="buttonBase
          w-[261px] h-[40px] bg-black text-white rounded-none  shadow-sm py-2  disabled:text-opacity-70 disabled:cursor-not-allowed
        "
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {step4 && !about ? (
          <div
            id="step4"
            className="pt-5 pb-8 px-8 bg-lightModal w-11/12 max-w-[711px] h-fit border-solid border-2 border-black z-10 rounded-none bg-white"
          >
            <div>
              <div className="flex justify-between mb-3">
                <div
                  onClick={goToStep3}
                  className="flex items-center gap-2 hover:cursor-pointer py-3 undefined"
                >
                  <img
                    alt="Go Back"
                    width="16"
                    height="12"
                    src="https://powered.by.dustlabs.com/cdn-cgi/image/width=32/https://y00ts.com/shared/icons/back-arrow.svg"
                  />
                </div>
                <div
                  onClick={closeSteps}
                  className="flex items-center gap-2 hover:cursor-pointer py-3"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1.67156 16C1.24668 16 0.821803 15.8435 0.486373 15.5082C-0.162124 14.8599 -0.162124 13.7869 0.486373 13.1387L13.1433 0.486203C13.7918 -0.162068 14.8651 -0.162068 15.5136 0.486203C16.1621 1.13447 16.1621 2.20747 15.5136 2.85574L2.85674 15.5082C2.54367 15.8435 2.09644 16 1.67156 16Z"></path>
                    <path d="M14.3284 16C13.9036 16 13.4787 15.8435 13.1433 15.5082L0.486373 2.85574C-0.162124 2.20747 -0.162124 1.13447 0.486373 0.486203C1.13487 -0.162068 2.20825 -0.162068 2.85674 0.486203L15.5136 13.1387C16.1621 13.7869 16.1621 14.8599 15.5136 15.5082C15.1782 15.8435 14.7533 16 14.3284 16Z"></path>
                  </svg>
                </div>
              </div>
              <div className="flex flex-col gap-2 items-center w-full">
                <div className="w-full flex flex-col items-center text-center">
                  <div className="font-primaryBold text-xl">
                    {projectName !== "" ? <>{projectName}</> : <></>} Draw.
                  </div>
                  <div className="text-fontSecondary w-5/6 mt-1 text-xs">
                    <ul>
                      <li>Take a leap for y00topia with your bl00p</li>
                      <li>Use the slider to increase your odds of drawing a y00t</li>
                      <li>Draw winners need an EVM wallet to claim their y00t</li>
                      <li>1 bl00p = 1 Draw</li>
                    </ul>
                  </div>
                </div>
                <TokensTable
                  tokens={tokens}
                  solBalance={solBalance}
                  setSuccessRate={setSuccessRate}
                />
              </div>
            </div>
            <div className="flex mt-6 lg:mt-0  w-full justify-between">
              <div className="min-w-1/3 flex flex-col justify-center items-center first:border-r-2 last:border-l-2 border-lightBorder py-2 px-2 sm:px-3 md:px-8 mb-2 text-center">
                <p className="text-fontSecondary text-[13px] md:text-[16px]">y00ts Drawn</p>
                <p>2/5</p>
              </div>
              <div className="min-w-1/3 flex flex-col justify-center items-center first:border-r-2 last:border-l-2 border-lightBorder py-2 px-2 sm:px-3 md:px-8 mb-2 text-center">
                <p className="text-fontSecondary text-[13px] md:text-[16px]">Success Rate</p>
                <p>{successRate}%</p>
              </div>
              <div className="min-w-1/3 flex flex-col justify-center items-center first:border-r-2 last:border-l-2 border-lightBorder py-2 px-2 sm:px-3 md:px-8 mb-2 text-center">
                <p className="text-fontSecondary text-[13px] md:text-[16px]">SOL Balance</p>
                <p>{roundedSolBalance} SOL</p>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        {!about ? (
          <>
            <div className="flex flex-col items-center pt-12">
              <p className="font-primary leading-[22px] md:leading-[25.3px] text-[18px] md:text-[21px] text-center w-full">
                To learn more about Draw<span className="inline-block"></span>
              </p>
              <div
                className="flex gap-4 cursor-pointer justify-center w-full"
                onClick={() => setAbout(true)}
              >
                <img
                  alt="click-here-button"
                  loading="lazy"
                  width="200"
                  src="/click-here-button.png"
                />
              </div>
            </div>

            <div className="fixed top-0 left-0 flex justify-center items-center w-screen h-screen z-[-1]">
              <video className="w-screen h-screen object-cover" loop autoPlay muted playsInline>
                <source src="/bg-animated.mp4" type="video/mp4" />
              </video>
            </div>
          </>
        ) : (
          <></>
        )}

        {about ? (
          <div className="flex flex-col items-center justify-start h-full px-4 overflow-x-hidden">
            <div className="mb-10 sm:my-16 heightSmall:my-3 h-full w-full px-4 overflow-x-hidden">
              <div className="flex flex-col lg:flex-row items-center justify-center gap-10 lg:gap-32">
                <div className="flex-col max-w-[500px]">
                  <div className="max-w-[500px] flex flex-col justify-center items-center lg:items-start !w-full !text-left">
                    <div
                      onClick={() => setAbout(false)}
                      className="flex items-center gap-2 hover:cursor-pointer"
                    >
                      <img
                        alt="Go Back"
                        width="34"
                        src="https://powered.by.dustlabs.com/cdn-cgi/image/width=32/https://y00ts.com/shared/icons/back-arrow.svg"
                      />
                    </div>
                    <div>
                      <h2 className=" text-center text-lightFontPrimary py-2 !text-[26px] md:!text-5xl font-primaryBold whitespace-nowrap">
                        Draw.
                      </h2>
                      <h2 className="text-center font-primaryBold py-2 !text-[20px] md:!text-xl leading-[18px] lg:leading-4">
                        Pioneering a new era of{" "}
                        <span className="text-blue font-primaryBold">cross-chain</span>{" "}
                        collaboration.
                      </h2>
                    </div>

                    <div>
                      <p className="text-[16px] mt-8 md:text-[19px] leading-[22px] font-primary text-justify md:leading-[25.3px]">
                        y00tLabs has nominated a diverse group of communities to join the Draw. Each
                        has its own Draw and has received 500 bl00ps that can draw{" "}
                        <span className="font-primaryBold">5 y00ts</span>.
                      </p>
                      <p className="text-[16px] mt-6 md:text-[19px] leading-[22px] font-primary text-justify md:leading-[25.3px]">
                        The odds of drawing a y00t can be as high as{" "}
                        <span className="font-primaryBold">58%</span> but keep in mind that once
                        all y00ts are drawn, bl00ps expire, so enter in time.
                      </p>
                      <p className="text-[16px] mt-6 md:text-[19px] leading-[22px] font-primary text-justify md:leading-[25.3px]">
                        We&apos;re airdropping{" "}
                        <span className="font-primaryBold text-orange">BTC DeGod #5653</span> to 1
                        Draw participant. We&apos;ll randomly select the winning wallet and announce
                        it on <span className="font-primaryBold">May 5th</span> on Discord (with
                        claim instructions).
                      </p>
                      <p className="text-[16px] mt-6 md:text-[19px] leading-[22px] font-primary text-justify md:leading-[25.3px]">
                        Draw marks the first stage of our game plan to{" "}
                        <span className="font-primaryBold">unify</span> the Solana-and Polygon NFT
                        ecosystems.
                      </p>
                      <p className="text-[16px] mt-6 md:text-[19px] leading-[22px] font-primary text-justify md:leading-[25.3px]">
                      We’ll reveal more once all the Draws are finished. 
                        <span className="font-primaryBold text-red"> Stay tuned</span>!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="border-2 border-lightBorder flex flex-col justify-between items-center pt-10">
                  <img
                    className="transform scale-x-[-1]"
                    width="600"
                    src="/art-image-group.png"
                    alt="solutions image"
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </main>
    </>
  );
}

export default Flow;
